import { GROUP_PATCH_DIALOG_RECEIVE } from './group'
import { PERMISSION_PUT_DIALOG_RECEIVE } from './permission'
import { ROLES_PUT_DIALOG_RECEIVE } from './role'
import { USER_GROUP_PATCH_DIALOG_RECEIVE } from './user'


export const UNFLAG_DATA_REFRESH = 'refresh/UNFLAG_DATA_REFRESH'
const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

const initialState = {
  dataRefreshRequired: {
    users: false,
    groups: false,
    roles: false,
    permissions: false
  },
  locationChangeCounter: 0 // after loading initial data and redirecting to /users, for example, we don't want to set dataRefreshRequired. Counter ensures we don't things twice
}
// TODO: All use cases have not yet been flushed out. DELETES should also share this functionality.
export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case GROUP_PATCH_DIALOG_RECEIVE:
      return {
        ...state,
        dataRefreshRequired: { ...state.dataRefreshRequired, users:true }
      }
    case LOCATION_CHANGE:
      if (action.payload.pathname === '/groups') {
        if (state.locationChangeCounter < 2 ) {
          return {
            ...state,
            locationChangeCounter: state.locationChangeCounter + 1
          }
        }
        return {
          ...state,
          dataRefreshRequired: { ...state.dataRefreshRequired, groups:true }
        }
      } else if (action.payload.pathname === '/users') {
        if (state.locationChangeCounter < 2 ) {
          return {
            ...state,
            locationChangeCounter: state.locationChangeCounter + 1
          }
        }
        return {
          ...state,
          dataRefreshRequired: { ...state.dataRefreshRequired, users:true }
        }
      }
      return {...state}
    case PERMISSION_PUT_DIALOG_RECEIVE:
      return {
        ...state,
        dataRefreshRequired: { ...state.dataRefreshRequired, roles:true }
      }
    case ROLES_PUT_DIALOG_RECEIVE:
      return {
        ...state,
        dataRefreshRequired: { ...state.dataRefreshRequired, permissions:true }
      }
    case USER_GROUP_PATCH_DIALOG_RECEIVE:
      return {
        ...state,
        dataRefreshRequired: { ...state.dataRefreshRequired, users:true, groups: true }
      }
    case UNFLAG_DATA_REFRESH:
      const unflaggedDataRefresh = { ...state.dataRefreshRequired, [action.page]:false }
      return {
        ...state,
        dataRefreshRequired: unflaggedDataRefresh
      }
    default:
      return state
  }
}

export const unflagDataRefresh = (page) => ({type: UNFLAG_DATA_REFRESH, page})

export default reducer
